import { Copy } from '../copy/Copy';

export const COMMUNITY_NAV_TABS = [
  Copy.generate('Global.feed'),
  Copy.generate('Global.leaderboards'),
  Copy.generate('Global.music'),
];
